import CareLevelsDialog from "@/views/settings/careLevels/careLevelsDialog/careLevelsDialog.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import firebase from "firebase";
import { EventLocations } from "@/enums/EventLocations";

export default {
    name: "CareLevels",
    components: {
        CareLevelsDialog,
        ConfirmDlg
    },
    data() {
        return {
            loading: true,
            disabled: false,
            search: "",
            headers: [
                {
                    text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
                    align: "start",
                    value: "name",
                    width: 600
                },
                {
                    text: this.$i18n.messages[this.$i18n.locale]['LevelsOfCare.Wings'],
                    align: "start",
                    value: "wingsNames",
                    sortable: false,
                },
                {
                    align: "end",
                    value: "id",
                    width: 100,
                    sortable: false,
                }
            ],
        }
    },
    computed: {
        careLevels() {
            return this.$store.state.careLevelsModule.careLevels
        },
        wings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        facilityId() {
            return this.$store.state.authModule.currentFacility;
        },
    },
    async created() {
        await this.$store.dispatch("getEventWings");
        await this.$store.dispatch("getCareLevels");
        this.loading = false;
    },
    methods: {
        openDialogAddCareLevel() {
            this.$refs.CareLevelsDialog.open("add");
        },
        openDialogUpdateCareLevel(item) {
            this.$refs.CareLevelsDialog.open("update", item);
        },
        deleteCareLevel(item) {
            this.$refs.ConfirmDlg
                .open(null, this.$i18n.messages[this.$i18n.locale]['LocationManagement.DeleteMessage'].replace('[name]', item.name), false, '', { noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'], yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Delete'] })
                .then(async response => {
                    if (response && response.agree) {
                        await this.deleteCareLevelOnWings(item.id)
                        await this.$store.dispatch("deleteCareLevel", item).then(() => {
                            this.$toast.open({
                                message: this.$i18n.messages[this.$i18n.locale]['LocationManagement.LocationSuccessfullyDeleted'],
                                type: "success"
                            });
                        })
                    }
                });
        },
        async deleteCareLevelOnWings(careLevelId: string) {
            await firebase
                .firestore()
                .collection("eventLocations")
                .where("facilityId", "==", this.facilityId)
                .where("careLevelId", "==", careLevelId)
                .get()
                .then((querySnapshot) => {
                    if (querySnapshot.docs && querySnapshot.docs.length) {
                        querySnapshot.docs.forEach((item) => {
                            if (item.data().type === EventLocations.Wing) {
                                item.ref.update({ careLevelName: null, careLevelId: null })
                            }
                        })
                    }
                })
        }
    }
}